var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsFixedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gps_fixed_light"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 16.5,
    cy: 16.5,
    r: 9.625,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 16.5,
    cy: 16.5,
    r: 2.75,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 84",
    d: "M16.5 6.875V4.125",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 86",
    d: "M26.125 16.5L28.875 16.5",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 85",
    d: "M16.5 28.875L16.5 26.125",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 87",
    d: "M4.125 16.5H6.875",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFixedLight);
export default __webpack_public_path__ + "static/media/Gps_fixed_light.45dd5566c38bf6fb99f3baa6fc064c7d.svg";
export { ForwardRef as ReactComponent };